import { reduce } from 'lodash-es';

import { useAppSelector } from 'src/app/store/hooks';
import { useBillingBillingSettingsRetrieveQuery } from 'src/common/external/bambi-api/bambiApi';
import { formatPhoneNumber } from 'src/common/formatPhoneNumber';
import { selectCurrentOrganization } from 'src/features/auth/selectors';

interface PaymentLinkTemplatePreviewProps {
  text: string | undefined;
}
export function PaymentLinkTemplatePreview({
  text,
}: PaymentLinkTemplatePreviewProps) {
  const currentOrganization = useAppSelector(selectCurrentOrganization);
  const { data } = useBillingBillingSettingsRetrieveQuery({});

  const previewData: PaymentLinkEmailData = {
    invoice_number: 'INV-01',
    payment_link: 'https://secure-payment.domain/',
    organization_name: currentOrganization?.name || 'Organization Name',
    billing_email: data?.email ?? 'billing@email.com',
    billing_phone: formatPhoneNumber(data?.phone_number ?? '+15555555555'),
  };

  return (
    <div className="flex w-full flex-col gap-2">
      <h4 className="text-sm font-medium text-gray-700">Preview</h4>
      <pre
        className="whitespace-pre-wrap text-sm"
        dangerouslySetInnerHTML={{
          __html: paymentLinkEmailTemplateRenderer(text ?? '', previewData),
        }}
      />
    </div>
  );
}

export type PaymentLinkEmailData = {
  invoice_number: string;
  payment_link: string;
  organization_name: string;
  billing_email: string;
  billing_phone: string;
};
export function paymentLinkEmailTemplateRenderer(
  text: string,
  data: PaymentLinkEmailData,
  renderForEmail?: boolean
) {
  const result = reduce(
    data,
    (result, value, key) => {
      let renderedValue = value;
      if (key === 'payment_link') {
        const className = renderForEmail
          ? ''
          : 'class="border-none text-xs text-blue-600 underline"';

        const onClick = renderForEmail ? '' : 'onClick="return false;"';
        renderedValue = `<a ${className} ${onClick} href="${value}">Pay Invoice: ${data.invoice_number}</a>`;
      }

      return result.replaceAll(`{{${key}}}`, renderedValue);
    },
    text
  );

  if (renderForEmail) {
    return `<div style="white-space:pre-wrap">${result}</div>`;
  }

  return result;
}
